import {apisettigs} from '../../settings.js';

async function CheckAuth(token) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json charset=utf-8', },
        body: JSON.stringify({ token: token })
    };

    const response = await fetch(apisettigs.endpoints.checkauth, requestOptions);
    const data = await response.json();

    if (data.auth === 'ok'){
        if (data.user_id === window.sessionStorage.getItem("userId"))
        {
            return true;
        }
        else{
            return false;
        }
    }
    else{
        return false;
    }
}

export default CheckAuth;